<mat-form-field
        [ngClass]="wrapperClasses"
        [appearance]="input.appearance"
        [floatLabel]="input.floatLabel"
        class="full-width">
    <mat-label>{{input.label}}</mat-label>
    <ng-template #infoTemplate></ng-template>
    <input
            #inputElement
            matInput
            (blur)="blurEvent($event)"
            [attr.maxlength]="input.maxChars ? input.maxChars : null"
            [type]="input.textType"
            [aria-describedby]="inputElement.id + editPromptSuffix"
            [required]="input.required"
            [placeholder]="input.placeholder"
            [formControl]="input.control"
            (blur)="blurEvent($event)"
            (focus)="focusEvent($event)">
    <div class="has-max-chars" *ngIf="hasMaxChars">{{input.control?.value?.length ? input.control.value.length : 0}} / {{input.maxChars}}</div>
    <mat-error>{{errorMessage}}</mat-error>
    <mat-hint [ngClass]="hint?.class">{{hint?.message}}</mat-hint>
</mat-form-field>